import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";

const LOGO = "https://i.imgur.com/27IUlf9.png";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setDone(true);
      toast.success("Si el email existe, se ha enviado un enlace");
    } catch { toast.error("Error"); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#f7f7f4] flex items-center justify-center p-6">
      <div className="eu-card w-full max-w-md p-8 lg:p-10">
        <img src={LOGO} alt="" className="h-10 mx-auto" />
        <h1 className="font-display text-3xl text-[#133322] text-center mt-6">Restablecer contraseña</h1>
        {done ? (
          <p className="text-center text-sm text-[#5c6b61] mt-6">Revisa tu correo. El enlace expira en 1 hora.</p>
        ) : (
          <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="forgot-form">
            <div>
              <label className="eu-data-label block mb-2">Email</label>
              <input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full bg-[#f7f7f4] rounded-xl px-4 py-3 text-sm border border-[#e5e8e2] focus:border-[#133322] outline-none" data-testid="forgot-email" />
            </div>
            <button disabled={busy} className="eu-btn-primary w-full justify-center" data-testid="forgot-submit">
              {busy ? "Enviando..." : "Enviar enlace"}
            </button>
          </form>
        )}
        <div className="mt-6 text-center text-xs"><Link to="/admin/login" className="text-[#5c6b61] hover:text-[#133322]">← Volver al login</Link></div>
      </div>
      <Toaster richColors position="top-center" />
    </div>
  );
}
